export default "__VITE_ASSET__D8eFa_hU__"